import React from 'react';

export function ClearIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M37.293 13.527a1 1 0 000-1.414l-1.406-1.406a1 1 0 00-1.414 0L24 21.18 13.527 10.707a1 1 0 00-1.414 0l-1.406 1.406a1 1 0 000 1.414L21.18 24 10.707 34.473a1 1 0 000 1.414l1.406 1.406a1 1 0 001.414 0L24 26.82l10.473 10.473a1 1 0 001.414 0l1.406-1.406a1 1 0 000-1.414L26.82 24l10.473-10.473z" />
    </svg>
  );
}
